import { call, put } from "redux-saga/effects";

import * as api from "../../api/TdsApi";
import * as types from "../../constants/actionTypes";
import { createErrorMessageAction } from "../../utils/TypescriptUtils";

export function* getMyQueueRequestsSaga(action) {
  try {
    let returnRequests = [];
    let errors = "";

    for (var i = 0; i < action.environments.length; i++) {
      let requests = [];
      try {
        requests = yield call(api.getMyQueueRequests, action.user, action.environments[i]);
      } catch (error) {
        errors += `Unable to retrieve queue requests for environment ${action.environments[i].display}. Error ${error}\n`;
      }

      // Add environment to each queue request object, add to returnRequests
      for (var j = 0; j < requests.length; j++) {
        requests[j].environment = action.environments[i];
        returnRequests.push(requests[j]);
      }
    }
    yield put({ type: types.FETCH_MYQUEUEREQUESTS_SUCCESS, returnRequests });

    if (errors.length > 0) {
      throw new Error(errors);
    }
  } catch (error) {
    yield put(createErrorMessageAction(types.FETCH_MYQUEUEREQUESTS_ERROR, error));
  }
}

export function* cancelQueueRequestSaga(action) {
  try {
    const response = yield call(api.cancelQueueRequest, action.id, action.environment);
    yield put({ type: types.CANCEL_QUEUE_REQUEST_SUCCESS, response });
    if (window.location) {
      window.location.pathname = "/";
    }
  } catch (error) {
    yield put(createErrorMessageAction(types.CANCEL_QUEUE_REQUEST_ERROR, error));
  }
}
